/*
 * @author Oleksandr Papka <papkaos>
 */
angular.module('popup.notification', ['popup']);